module.exports = __webpack_public_path__ + "static/media/check-red.c205a537.svg";